<div class="panel fx-column" (keyup.enter)="submit()">
  <div class="fx-row align-items-center justify-content-start">
    <img src="/assets/img/logo.svg" height="60">
  </div>
  <div class="fx-column fx-flex-100 align-items-center justify-content-center panel-content">
    <div class="fx-row fx-wrap justify-content-center align-items-center">
      <div class="fx-column fx-flex-100 align-items-center justify-content-center">
        <span class="title main bold">{{'LOGIN.TITLE' | translate}}</span>
        <span class="text">{{'LOGIN.SUBTITLE' | translate}}</span>
      </div>
      <div class="fx-column mv-30 fx-flex-50">
        <ng-container *ngIf="step === 'email'">
          <app-input [placeholder]="('LOGIN.EMAIL' | translate) + '...'" type="text" prefix="mail" class="mb-10"
            [(value)]="email" [error]="errors.email" [bottomWrapper]="true" [autoFocus]="true"
            #emailInput></app-input>
          <div class="fx-row align-items-center justify-content-center mt-10 fx-flex">
            <button class="main-button fx-flex" (click)="next()" [disabled]="loading">
              {{'LOGIN.CONTINUE' | translate}}
            </button>
          </div>
        </ng-container>

        <!-- Once chosen, the e-mail is shown as the account being signed in, not as a field: a click goes back.
             Enter acts on key up and stops there, or the panel would take the same key up as "Continue". -->
        <div class="fx-row justify-content-center mb-20" *ngIf="step !== 'email'">
          <button type="button" class="identity" (click)="changeEmail()" (keydown.enter)="$event.preventDefault()"
            (keyup.enter)="$event.stopPropagation(); changeEmail()"
            [title]="'LOGIN.OTHER_EMAIL' | translate" [attr.aria-label]="'LOGIN.OTHER_EMAIL' | translate">
            <mat-icon fontSet="material-icons-outlined">account_circle</mat-icon>
            <span class="address">{{email}}</span>
            <mat-icon>expand_more</mat-icon>
          </button>
        </div>

        <ng-container *ngIf="step === 'sso' && sso">
          <span class="text center mb-10">{{'LOGIN.SSO_HINT' | translate: { label: sso.label } }}</span>
          <div class="fx-row align-items-center justify-content-center mt-10 fx-flex">
            <button class="directory-button fx-flex" (click)="continueWithSso()" [disabled]="loading">
              <img *ngIf="sso.logo" [src]="sso.logo" alt="">
              <mat-icon *ngIf="sso.icon" fontSet="material-icons-outlined" aria-hidden="true">{{sso.icon}}</mat-icon>
              <span>{{sso.text | translate: { label: sso.label } }}</span>
            </button>
          </div>
          <div class="fx-column align-items-center justify-content-center mt-10" *ngIf="sso.passwordAllowed">
            <a class="small clickable" (click)="usePassword()">{{'LOGIN.USE_PASSWORD' | translate}}</a>
          </div>
        </ng-container>

        <ng-container *ngIf="step === 'password'">
          <!-- The e-mail field is gone: password managers still need to know which account this password belongs to. -->
          <input type="email" name="username" autocomplete="username" [value]="email" hidden>
          <app-input [placeholder]="('LOGIN.PASSWORD' | translate) + '...'" type="password" prefix="lock"
            [(value)]="password" [error]="errors.password" [bottomWrapper]="true" [autoFocus]="true"
            #passwordInput></app-input>
          <div class="fx-row align-items-center justify-content-end mt-10 fx-flex">
            <a class="small" href="/forgot-password">{{'LOGIN.FORGOT_PASSWORD' | translate}}</a>
          </div>
          <div class="fx-row align-items-center justify-content-center mt-10 fx-flex">
            <button class="main-button fx-flex" (click)="login()" [disabled]="loading">
              {{'ACTIONS.LOGIN' | translate}}
            </button>
          </div>
        </ng-container>
      </div>
      <div class="fx-column fx-flex-100 align-items-center justify-content-center">
        <a href="https://uz-ip.tech/en/contact" target="_blank" rel="noopener">{{'LOGIN.NO_ACCOUNT' | translate}}</a>
      </div>
    </div>
  </div>
  <div class="fx-column align-items-center justify-content-center">
    <img src="/assets/icons/icon.svg" height="50" class="mb-10">
    <a class="main">uz-ip.tech</a>
  </div>
</div>
